import { useTheme, useMediaQuery, IconButton, Typography, Box, Button } from '@mui/material'
import { useState, useEffect } from 'react'
import { Slant as Hamburger } from 'hamburger-react'
import { ClickAwayListener } from '@mui/base';
import useResponsiveHelper from '../hooks/useResponsiveHelper';
import { Link } from "react-router-dom"
export default function MobileMenu(props) {

    const isHomepage = window.location.pathname === '/'
    const { menuList, bg_color } = props 
    const [open, setOpen] = useState(false)
    const theme = useTheme()
    const [offset, setOffset] = useState(0)
    const largePhone = useMediaQuery(theme.breakpoints.between('sm', 'md'))
    const { isMobile, } = useResponsiveHelper()
    function simulateMouseClick() {
        var element = document.querySelector('div[class="hamburger-react"]');
        element.click()
        
    }
    const CustomLink = (name, path) => {
        return (
            <Link 
                to={path} 
                style={{
                    padding:"20px",
                    width:"100%",
                    display:"flex",
                    justifyContent: "center",
                    color: theme.palette.secondary.main,
                    fontFamily: 'Fredoka',
                    '&:hover': {
                        backgroundColor: 'rgba(100,100,100,0.1)',
                        borderRadius: 5,
                    },
                    '&:focus': {
                        backgroundColor: 'rgba(100,100,100,0.3)'
                    },
                    textDecoration: 'none',
                }}
                underline='none'>
                {name}
            </Link>
            
        )
    }

    return (
        <ClickAwayListener onClickAway={() => open ? simulateMouseClick() : null}>
            <Box>
                <Box sx={{
                    top:0,
                    right:'55px',
                    color: theme.palette.secondary.main,
                   
                }}>
                <Hamburger rounded direction={'left'}
                toggled={open}
                toggle={setOpen}
                size={42}
                />
                </Box>
                {open ? 
                    <Box id='menubox' sx={{
                        position: 'absolute',
                        top: '100px',
                        width: '100%',
                        left:0,
                        backgroundColor: bg_color,
                        display:'flex',
                        flexDirection:'column',
                        alignItems: 'center',
                        zIndex:2,
                        borderBottom: '2px solid #59666Eff',
                        borderRadius: '0 0 30px 30px',

                }}>
                    {menuList.map((item) => {
                        return (
                            <div onClick={() => setOpen(false)}>
                                <hr style={{width:'100%', border:"1px solid", borderColor: theme.palette.secondary.main}}/>
                                {CustomLink(item, item === "Apply" ? "/apply-online" : `/${item.toLowerCase()}`)}
                            </div>
                        )
                    })
                    }
                    </Box> 
                : null }
            </Box>
        </ClickAwayListener>


    )

}